module.exports = __webpack_public_path__ + "static/media/html.887da672.png";